import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Link } from "react-router-dom";
import {
    APIS,
    SF_USR_ROLE_HIST_SRCH,
    SG_CSTM_USR_EXCEL_LIST,
    SG_CSTM_USR_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/rolehist/services/PtliRoleHistService";
import dayjs from "dayjs";

/*
 * Custom Office User Role History Management List
 * !== 세관 사용자 권한 이력 목록 ==!
 */
export const PTLI1003007Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const [load, setLoad] = useState(false);

    const form = {
        cstmRoleSrch: useForm({ defaultSchema: SF_USR_ROLE_HIST_SRCH }),
    };

    const grid = {
        gridCstmUsrList: useGrid({
            defaultSchema: SG_CSTM_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        gridCstmUsrExcelList: useGrid({
            defaultSchema: SG_CSTM_USR_EXCEL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmUsrList: useFetch({
            api: (page = grid.gridCstmUsrList.page, size = grid.gridCstmUsrList.size) =>
                APIS.getCstmUsrList(form.cstmRoleSrch.getValues(), page, size),
            enabled: form.cstmRoleSrch.isSubmitted,
            key: [grid.gridCstmUsrList.page, grid.gridCstmUsrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.cstmRoleSrch.getValues(),
                    page: grid.gridCstmUsrList.page,
                    size: grid.gridCstmUsrList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Get a excel list of Customs Officer. !== 세관직원 엑셀 목록을 조회한다. ==!
        getCstmUsrExcelList: useFetch({
            api: (data: any) => (load ? APIS.getCstmUsrExcelList(data) : null),
            enabled: comnUtils.isEmpty(form.cstmRoleSrch.errors),
            onSuccess: () => {
                if (load) {
                    grid.gridCstmUsrExcelList.exportExcel({
                        // Internal Portal Customs User Information !== 내부 포털_세관_사용자 정보 ==!
                        excelName: `${t("L_INT_PTL")}_${t("L_CSTM")}_${t("T_USR_INFO")}_${dayjs().format(
                            "DD/MM/YYYY HHmm",
                        )}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const render = {
        cstmUsrList: {
            cell: {
                usrNm: (props: any) => {
                    const { value, rowValues } = props;
                    return <Link to={`${URLS.ptli1003008q}/${rowValues.usrDmnId}`}>{value}</Link>;
                },
            },
        },
    };

    const handler = {
        onSrchClick: form.cstmRoleSrch.handleSubmit(() => fetch.getCstmUsrList.fetch()),
        onClear: () => {
            form.cstmRoleSrch.clearValues();
            grid.gridCstmUsrList.getData().length > 0 && grid.gridCstmUsrList.clearData();
        },
    };

    useEffect(() => {
        pgeStore?.form && form.cstmRoleSrch.setValues(pgeStore.form);
        pgeStore?.form && handler.onSrchClick();
    }, [theme]);

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getCstmUsrExcelList.fetch(store.form);
        }
    }, [load]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmRoleSrch.schema.usrDmnId} />
                            <Group.Control {...form.cstmRoleSrch.schema.cstmOfcrNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmRoleSrch.schema.cstmCd} />
                            <Group.Control {...form.cstmRoleSrch.schema.cstmOfcrNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    {/* <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    setLoad(true);
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout> */}
                    <Group.Title title={"T_CSTM_OFCR_LIST"} />
                    <Grid
                        {...grid.gridCstmUsrList.grid}
                        data={fetch.getCstmUsrList.data?.cstmUsrList}
                        render={render.cstmUsrList}
                    />
                </Group.Body>
            </Group>
            <Group hidden>
                <Grid {...grid.gridCstmUsrExcelList.grid} data={fetch.getCstmUsrExcelList.data?.cstmUsrExcelList} />
            </Group>
        </Page>
    );
};
